'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import useIsBrowser from 'hooks/useIsBrowser';
import usePostHogFeatureFlag from 'hooks/usePostHogFeatureFlag';
import InstantSearchMobileLegacy from './instant-search-mobile/InstantSearchMobileLegacy';
import InstantSearchMobileNext from './instant-search-mobile';
const InstantSearchMobile = props => {
  const $ = _c(4);
  const isBrowser = useIsBrowser();
  const postHogFlag = usePostHogFeatureFlag("consumerSearchBarNext");
  if (!isBrowser) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const useNextVersion = postHogFlag === "test" || isNewConsumerApp;
  let t0;
  if ($[1] !== props || $[2] !== useNextVersion) {
    t0 = useNextVersion ? <InstantSearchMobileNext {...props} /> : <InstantSearchMobileLegacy {...props} />;
    $[1] = props;
    $[2] = useNextVersion;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
export default InstantSearchMobile;